import { getMessaging } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD626LW6ew3yQCdVGZ3phVwEEkGDYgY0aI",
  authDomain: "imwow-baa22.firebaseapp.com",
  projectId: "imwow-baa22",
  storageBucket: "imwow-baa22.firebasestorage.app",
  messagingSenderId: "436140738344",
  appId: "1:436140738344:web:56eaf7ad926e62eb8db21d",
  measurementId: "G-3GQPTEH26G",
};

navigator.serviceWorker.getRegistrations().then((registrations) => {
  registrations.forEach((registration) => {
    registration.unregister();
  });
});

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const analytics = getAnalytics(app);
